// Ensure a global alias exists for libraries that expect `global` (Node-style)
// without using Vite's define text replacement, which can break import paths.
(function initGlobalAlias() {
  try {
    const g: any = typeof globalThis !== "undefined" ? globalThis : (window as any);
    if (g && typeof g === "object" && g.global == null) {
      g.global = g;
    }
  } catch {
    // Ignore if not in a browser-like environment
  }
})();
